import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useHistory } from 'react-router-dom';
import { FullPageModal, FullPageModalHeaderStart, FunctionalLoader, Typography } from 'seagull';
import RestfulWrapper from '~/components/RestfulWrapper/RestfulWrapper';
import { routes } from '~/constants';
import { useStore, useStoreActions } from '~/contexts';
import { useContacts } from '~/hooks/reactQuery/queries/useContacts';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { useServiceTemplateApi } from '~/hooks/useServiceTemplateApi';
import { useLocaleKeys } from '~/i18n';
import { wait } from '~/infra/utils';
import StripeElementsProvider from '~/providers/StripeElementsProvider';
import { selectors } from '~/store/state-selectors';
import FeatureFlagsRelationshipContext from '../FeatureFlagsRelationshipContext';
import styles from './FullPageInvoice.module.scss';
import FullPageInvoiceWithData from './FullPageInvoiceWithData';
export default function FullPageInvoice(props) {
    const { invoiceId, relationshipId, dismissModal, onRefresh, hideDropdownActions } = props;
    const { t: invoiceTexts } = useLocaleKeys('invoice.fullPage');
    const { api } = useStoreActions();
    const { contacts, refresh: fetchContacts, isLoading: contactsLoading } = useContacts({
        refreshOnMount: true
    });
    const isVendor = useStore(selectors.user.isVendor);
    const showQboIntegration = useStore(selectors.integration.showQboIntegration);
    const showInvoiceQboSection = useStore(selectors.integration.showInvoiceQboSection);
    const showXeroIntegration = useStore(selectors.integration.showXeroIntegration);
    const showInvoiceXeroSection = useStore(selectors.integration.showInvoiceXeroSection);
    const history = useHistory();
    const serviceTemplateApi = useServiceTemplateApi();
    const { EXTERNAL_INVOICES_ENDPOINT } = useFeatureFlags();
    const fetch = async (isInitialLoading)=>{
        if (!invoiceId || !relationshipId) throw new Error('missing data');
        const getInvoice = EXTERNAL_INVOICES_ENDPOINT ? api.invoice.getInvoice : api.invoice.getByID;
        const [invoice, relationship, serviceTemplates] = await Promise.all([
            getInvoice(invoiceId, !isVendor),
            api.relationship.get(relationshipId),
            showInvoiceQboSection || showInvoiceXeroSection ? serviceTemplateApi.getForInvoice(invoiceId) : Promise.resolve([]),
            isInitialLoading ? Promise.resolve() : fetchContacts()
        ]);
        return {
            relationship,
            invoice,
            serviceTemplates
        };
    };
    return /*#__PURE__*/ _jsx(FullPageModal, {
        contentSkin: "white",
        testId: "fpi",
        onClose: ()=>dismissModal(),
        children: /*#__PURE__*/ _jsx(StripeElementsProvider, {
            children: /*#__PURE__*/ _jsx(RestfulWrapper, {
                initialArgs: {
                    isInitialLoading: true
                },
                fetch: (param)=>{
                    let { isInitialLoading } = param;
                    return fetch(isInitialLoading);
                },
                renderChild: (param)=>{
                    let { data, refresh } = param;
                    return /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(FunctionalLoader, {
                                show: contactsLoading
                            }),
                            /*#__PURE__*/ _jsx(FeatureFlagsRelationshipContext, {
                                vendorId: data.relationship.vendor.id,
                                children: /*#__PURE__*/ _jsx(FullPageInvoiceWithData, _object_spread_props(_object_spread({}, data), {
                                    contacts: contacts,
                                    showQboIntegration: showQboIntegration,
                                    showInvoiceQboSection: showInvoiceQboSection,
                                    showXeroIntegration: showXeroIntegration,
                                    showInvoiceXeroSection: showInvoiceXeroSection,
                                    isVendor: isVendor,
                                    onRefresh: onRefresh,
                                    hideDropdownActions: hideDropdownActions,
                                    refresh: ()=>refresh({
                                            args: {
                                                isInitialLoading: false
                                            }
                                        }),
                                    onRedirectToPaymentMethods: async ()=>{
                                        dismissModal();
                                        await wait(0);
                                        history.push(routes.paymentMethods(data.relationship.id));
                                    }
                                }))
                            })
                        ]
                    });
                },
                renderError: ()=>/*#__PURE__*/ _jsxs("div", {
                        className: styles.error,
                        "data-testid": "fpi-error",
                        children: [
                            /*#__PURE__*/ _jsx(FullPageModalHeaderStart, {
                                children: invoiceTexts.errorTitle()
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "h6",
                                children: invoiceTexts.loadError()
                            })
                        ]
                    })
            })
        })
    });
}
